export default __webpack_public_path__ + "static/media/knesset.30ae8d08.png";